<template>
  <generic-modal
    :title="$t('data source')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('source')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/emarketing/datasource/source-catalog"
              name_field="model"
              value_field="model"
              @selected="source_changed"
              ref="source_dropdown"
            >
            </generic-dropdown>
          </div>
        </div>
      </div>
      <div v-if="selected_source && selected_source.fields">
        <div class="title is-6">{{ $t("available fields") }}</div>
        <div class="tags">
          <span
            class="tag is-info"
            v-for="field in selected_source.fields"
            :key="field"
          >
            {{ field }}
          </span>
        </div>
      </div>
      <div class="field mt-5">
        <label class="label">{{
          $t("sequelize where condition object")
        }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.settings.condition"
          ></textarea>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("sequelize include array") }}</label>
        <div class="control">
          <textarea class="textarea" v-model="meta.settings.include"></textarea>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import moment from "moment";

export default {
  name: "CreateProductModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {
      selected_source: undefined,
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {
        settings: {
          condition: "",
          include: "",
        },
      },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(datasource_uuid) {
      let v = this;
      v.set_initial_state();
      v.datasource_uuid = datasource_uuid;
      get("/emarketing/datasource", { uuid: datasource_uuid })
        .then((response) => {
          v.meta = response;
          if (response.settings.model)
            v.$refs.source_dropdown.set_value(response.settings.model);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      if (!v.datasource_uuid) {
        put("/emarketing/datasource", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/emarketing/datasource", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {
          condition: "",
          include: "",
        },
      };
      v.$refs.source_dropdown.clear();
      v.selected_source = undefined;
      v.error = "";
      // v.uuid = "";
    },
    source_changed(value) {
      let v = this;
      if (value) {
        v.meta.settings.model = value.model;
        v.selected_source = value;
      }
    },
    source_display(item) {
      return `${item.model} - ${item.email_field}`;
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
